import React from "react";
import { useSelector } from "react-redux";
import Header from "./components/shared/header/Header";
import AppRouting from "./AppRouting";
import Footer from "./components/shared/footer/Footer";

function Layout() {
  const { fontSize } = useSelector((state) => state.homeSlice);

  return (
    <div style={{ fontSize: `${fontSize}px` }}>
      <main>
        <Header />
        <AppRouting />
        <Footer />
      </main>
    </div>
  );
}

export default Layout;
